// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BadgePresentationProps } from "@eisinc/MobiusOverrides/Badge/Badge";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { formatMonthYearDate, mergeWithCss } from "@eisinc/XDL/Utilities";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import Badge, { BadgeTypeValues } from "@insite/mobius/Badge";
import React, { useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    product?: CartLineModel | ProductContextModel | ProductModel;
    extendedStyles?: BadgePresentationProps;
}

export const previouslyPurchasedbadgeStyles: BadgePresentationProps = {
    textBadgeCss: {
        css: css`
            font-size: ${fontConfig.xxSmall.size}px;
            font-weight: ${fontConfig.weight.regular};
            line-height: ${fontConfig.singleLinexxSmall.lineHeight};
            letter-spacing: 0;
            white-space: nowrap;
        `,
    },
    textBadgeWrapperCss: {
        css: css`
            display: flex;
            width: fit-content;
            position: absolute;
            padding: 6px;
            opacity: 0.9;
            top: 0;
            left: 0;
        `,
    },
};

const PreviouslyPurchasedBadge = ({ product, extendedStyles }: OwnProps) => {
    const [styles] = useState(() => mergeWithCss(previouslyPurchasedbadgeStyles, extendedStyles));

    if (!product) {
        return null;
    }
    const productModel = "product" in product ? product.product : product;
    const lastPurchasedOn = productModel?.properties?.["lastPurchasedDate"]
        ? `${translate("Ordered")} ${formatMonthYearDate(productModel.properties["lastPurchasedDate"])}`
        : "";

    if (!lastPurchasedOn) {
        return null;
    }

    return (
        <Badge
            type={BadgeTypeValues.Text}
            value={lastPurchasedOn}
            badgeBackgroundColor="333333"
            badgeTextRounding={0}
            {...styles}
        />
    );
};

export default PreviouslyPurchasedBadge;
